import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "FTPOrSpreadData" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
